import { IndustryModuleCode, IndustryProductID, OptionAvailability } from './../../../model/industry';
import { MiGenParameters } from './../../../model/MiGenParameters';
import { OperationResult } from '@tb/auth';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { ItemsAdministrativeInfo } from 'src/app/model/configuration';
import { Feature, Option } from 'src/app/model/feature';
import { IndustryDescription } from 'src/app/model/industry';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { FragmentStatus } from 'src/app/industryeditor/models/industry-fragment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

//const MWFragmentWeights = require('src/app/portal/magoweb-management/mw-fragment-weights.json');
@Component({
    selector: 'ms-feature-element',
    templateUrl: './feature-element.component.html',
    styleUrls: ['./feature-element.component.scss'],
})
export class FeatureElementComponent implements OnInit {
    @Input() feature: Feature;
    @Input() featureDataSheet: string;
    @Input() industry: IndustryDescription;
    @Input() editionCode: string;
    @Output() onfeatureClick = new EventEmitter<Feature>();
    public isCartIndustry: boolean;
    public showMore = false;
    public currency = '€';
    public featurePricetxt;
    public messagefeaturePricetxt;
    public toggleSelected = false;
    public mluFeaturePricetxt;
    public featureDescription;
    language: string;
    componentIsInitialized: boolean = false;
    public ecommerceOptionDescri_beginning: string;
    public ecommerceOptionDescri_center: string;
    public ecommerceOptionDescri_end: string;
    public cmsObj: CmsObject[];
    public connectorsIds: string[] = [];
    public smallScreen: boolean = false;

    constructor(
        private variable: TranslatedVariables,
        private configurationService: ConfigurationService,
        private serviceUtilsService: ServiceUtilsService,
        public workflow: WorkFlowService,
        private dialog: MatDialog,
        public overlay: Overlay,
        public cmsService: CmsService,
        public storeRoleService: StoreRolesService,
        public magoWebService: MagoWebService,
        private breakpointObserver: BreakpointObserver
    ) {}

    async ngOnInit() {
        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
            this.smallScreen = result.matches;
        });
        await this.load();
        this.componentIsInitialized = true;
    }

    public async load() {
        if (!this.feature.CurrNrOfUser) this.feature.CurrNrOfUser = 0;
        this.getCmsObj();
        this.getConnectorsIds();
        this.featurePricetxt = this.getFeaturePricetxt() != '' ? this.getFeaturePricetxt() : '';
        this.messagefeaturePricetxt = this.getFeaturePricetxt() == '' ? this.variable.includedinbasepackage : '';
        this.featureDescription = this.getDescription(this.feature.Description);
        this.isCartIndustry = this.industry.ModuleCode == IndustryModuleCode.CART;
        if (this.industry.ProductID == IndustryProductID.MW) this.mluFeaturePricetxt = this.getFeatureMLUPricetxt();
    }
    async getConnectorsIds() {
        let opRes: OperationResult = await this.serviceUtilsService.getStoreParameterValue('connectors_OptionIds');
        let content = new MiGenParameters();
        content = opRes.Content as MiGenParameters;
        this.connectorsIds = content.Value.split(';');
    }

    async getCmsObj() {
        this.language = this.workflow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'industryconfigurator');
        this.ecommerceOptionDescri_beginning = this.cmsObj.find(
            (x) => x.ContentName == 'industryconfigurator.ecommerceOptionDescri_beginning'
        ).ContentTranslation;
        this.ecommerceOptionDescri_center = this.cmsObj.find(
            (x) => x.ContentName == 'industryconfigurator.ecommerceOptionDescri_center'
        ).ContentTranslation;
        this.ecommerceOptionDescri_end = this.cmsObj.find(
            (x) => x.ContentName == 'industryconfigurator.ecommerceOptionDescri_end'
        ).ContentTranslation;
    }

    getDescription(description: string) {
        return description == '' ? 'manca descrizione modulo' : description;
    }
    public hideDetails(fragment: string) {
        this.showMore = false;
        if (!document.getElementById(fragment)) return;
        document.getElementById(fragment).className = 'line-clamp';
    }
    public showDetails(fragment: string) {
        this.showMore = true;
        if (!document.getElementById(fragment)) return;
        document.getElementById(fragment).className = '';
    }
    public isTCCN_EPCN(optionID: string) {
        return this.connectorsIds.find((x) => x === optionID);
    }

    public isKKCN(optionID: string) {
        return optionID === 'KKCN';
    }

    public openDialog() {}
    public isNotAlways() {
        let optionInfo = this.feature.Options.find((x) => x.edition.toLowerCase() == this.editionCode.toLowerCase());
        if (this.industry.ModuleCode != IndustryModuleCode.ADSP) return true;
        if (!optionInfo || optionInfo.availability == '') {
            return true;
        }
        return optionInfo.availability != OptionAvailability.ALWAYS;
    }

    getFeaturePricetxt() {
        if (!this.editionCode) return;
        let optionInfo = this.feature.Options.find((x) => x.edition.toLowerCase() == this.editionCode.toLowerCase());
        if (!optionInfo || optionInfo.availability == '') {
            return '-';
        }

        if (optionInfo.availability.toLowerCase() == OptionAvailability.ALWAYS) {
            return ''; //this.variable.includedinbasepackage;
        }
        let price: ItemsAdministrativeInfo = undefined;
        if (!this.magoWebService.isSFT) {
            price = this.industry.SASPriceRanges.find(
                (x) => x.ModuleCode == this.feature.OptionID && x.EditionCode.toLowerCase() == this.editionCode.toLowerCase()
            );
        } else {
            price = this.industry.PriceRanges.find(
                (x) => x.ModuleCode == this.feature.OptionID && x.EditionCode.toLowerCase() == this.editionCode.toLowerCase()
            );
        }

        if (price == undefined || price.Price == 0) {
            return '-';
        }
        return price.Price.toFixed(2);
        //}
    }

    getFeatureMLUPricetxt() {
        if (!this.editionCode) return;
        let optionInfo = this.feature.Options.find((x) => x.edition.toLowerCase() == this.editionCode.toLowerCase());
        if (!optionInfo || optionInfo.availability == '') {
            return '-';
        }

        if (optionInfo.availability.toLowerCase() == OptionAvailability.ALWAYS) {
            return this.variable.includedinbasepackage;
        }
        //TODO quando saranno inseriti gli articoli
        let price: ItemsAdministrativeInfo = this.industry.MLUPriceRanges.find(
            (x) => x.ModuleCode == this.feature.OptionID && x.EditionCode.toLowerCase() == this.editionCode.toLowerCase()
        );
        if (price == undefined || price.Price == 0) {
            return '-';
        }
        return price.Price.toString();
    }

    getAvailability() {
        let otpion: Option = this.feature.Options.find((x) => x.edition.toLowerCase() == this.editionCode);
        if (!otpion) return;
        return otpion.availability.toLowerCase();
    }
    getFeaturePrice() {
        let price: ItemsAdministrativeInfo = this.industry.PriceRanges.find(
            (x) => x.ModuleCode == this.feature.OptionID && x.EditionCode == this.editionCode.toLowerCase()
        );
        if (price == undefined) return 0;
        this.currency = this.getFeatureCurrency(price);
        return price.Price;
    }
    onToggleChange(elem: Feature) {
        elem.isChecked = !elem.isChecked;
        elem.CurrNrOfUser = elem.isChecked ? 1 : 0;
        this.toggleSelected = elem.isChecked;
        elem.SelectedByUser = !elem.SelectedByUser;
        this.onfeatureClick.emit(elem);
    }
    getFeatureCurrency(price: ItemsAdministrativeInfo) {
        if (price == undefined) return '';
        return this.configurationService.getIndustryCurrencySymbol(price);
    }
    handleOptionMinus() {
        if (this.feature.CurrNrOfUser > 0) {
            this.feature.CurrNrOfUser--;
            this.feature.isChecked = true;
        } else {
            this.feature.CurrNrOfUser = 0;
            this.feature.isChecked = false;
        }
        this.onfeatureClick.emit(this.feature);
    }
    handleOptionPlus() {
        this.feature.CurrNrOfUser++;
        this.feature.isChecked = true;
        this.onfeatureClick.emit(this.feature);
    }
    public getCorrectClass(status: number, productID: string) {
        let styleCard = productID == IndustryProductID.MW ? 'fuse-card-small functionCardMagoWeb' : 'fuse-card-small functionCard';
        let styleCardPlanned =
            productID == IndustryProductID.MW
                ? 'fuse-card-small functionCardMagoWeb cardfunctionPlannedMW'
                : 'fuse-card-small functionCard cardfunctionPlannedMC';
        let styleCardPhaseOut = styleCard + ' cardfunctionPhaseout ';
        switch (status) {
            case FragmentStatus.Planned:
                return styleCardPlanned;
            case FragmentStatus.PhaseOut:
                return styleCardPhaseOut;
            default:
                return styleCard;
        }
    }

    public isPlanned(status: number) {
        return status === FragmentStatus.Planned;
    }

    public isPhaseOut(status: number) {
        return status === FragmentStatus.PhaseOut;
    }

    public getCorrectLineClass(productID: string) {
        return productID === IndustryProductID.MW ? 'greenLinePriceSelection' : 'orangeLinePriceSelection';
    }

    public getCorrectSwitchClass(productID: string) {
        return productID === IndustryProductID.MW ? 'MWSwitchSelection' : 'MCSwitchSelection';
    }

    public getCorrectSelectionArea(productID: string) {
        return productID === IndustryProductID.MW ? 'MWSelectionArea' : 'MCSelectionArea';
    }

    public setCorrectVisibility(productID: string, fetaureOtpions: Option[]) {
        let otpion: Option = fetaureOtpions.find((x) => x.edition.toLowerCase() == this.editionCode);
        if (!otpion) return;

        let availabilty = otpion.availability.toLowerCase();

        return productID != IndustryProductID.MW || availabilty != OptionAvailability.ALWAYS;
    }
    public showPhrase(fetaureOtpions: Option[]) {
        let otpion: Option = fetaureOtpions.find((x) => x.edition.toLowerCase() == this.editionCode);
        if (!otpion) return;

        let availabilty = otpion.availability.toLowerCase();
        return availabilty != OptionAvailability.STANDALONE;
    }
    public getCorrectPhraseVsStatus(status: number, releaseFrom: string, releaseTo: string) {
        switch (status) {
            case FragmentStatus.Available:
                return '';
            case FragmentStatus.Planned:
                return this.variable.availableFrom + releaseFrom;
            case FragmentStatus.PhaseOut:
                return this.variable.availableUntil + releaseTo;
        }
    }
}
